import { AxiosResponse } from 'axios';
import { customLeagueCreate, customLeagueDelete, customLeagueList, customLeagueUpdate } from '@/api/customLeague';
import { AppError } from '@/errors/appError';
import type { CustomLeagueItem } from '@/models/customLeaguePage';
import { baseListService, isRequestCanceled } from '@/services/baseService';
import { IListParams } from '@/types';
import { ICustomLeagueApiListResponse, ICustomLeagueFilters, ICustomLeagueUpdateParams, ICustomLeagueUpdateResponse } from '@/types/customLeaguePage';

export const customLeagueService = {
    async list(params: IListParams<ICustomLeagueFilters>): Promise<AxiosResponse<ICustomLeagueApiListResponse>> {
        try {
            return await baseListService<ICustomLeagueApiListResponse>(customLeagueList, params);
        } catch (e) {
            if (isRequestCanceled(e)) throw e;
            console.error('Custom League API Error:', e);
            throw new AppError('Unable to load custom league list, request error', { cause: e });
        }
    },

    async save(item: CustomLeagueItem): Promise<AxiosResponse<ICustomLeagueUpdateResponse>> {
        const row = item.toApiData();
        if (item.id) {
            return this.update({ rows: [row] });
        }
        return this.create({ rows: [row] });
    },

    async create(params: ICustomLeagueUpdateParams): Promise<AxiosResponse<ICustomLeagueUpdateResponse>> {
        try {
            return await customLeagueCreate(params);
        } catch (e) {
            console.error('Custom League create API Error:', e);
            throw new AppError('Unable to create custom league, request error', { cause: e });
        }
    },

    async update(params: ICustomLeagueUpdateParams): Promise<AxiosResponse<ICustomLeagueUpdateResponse>> {
        try {
            return await customLeagueUpdate(params);
        } catch (e) {
            console.error('Custom League update API Error:', e);
            throw new AppError('Unable to update custom league, request error', { cause: e });
        }
    },

    async delete(id: number): Promise<AxiosResponse<ICustomLeagueUpdateResponse>> {
        try {
            return await customLeagueDelete({ rows: [{ id }] });
        } catch (e) {
            console.error('Custom League delete API Error:', e);
            throw new AppError('Unable to delete custom league, request error', { cause: e });
        }
    },
};
